import * as z from "zod";
import { mutator } from "./mutator";

export const deauthorizeOAuthAppForServiceAccount = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {},
  permissions: {
    none: "compatibility no-op for retired service-account OAuth",
  },
  fn: () => Promise.resolve(),
});
